var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '../../lib/dom';
import './HintButton.less';
var HintButton = /** @class */ (function (_super) {
    __extends(HintButton, _super);
    function HintButton(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'HintButton';
        _this.el = _this.DIV({ className: "& Button", onClick: props.onClick }, ['-']);
        return _this;
    }
    return HintButton;
}(Component));
export { HintButton };
